export function formatSettlementReceipt(data) {
    const lines = [];

    const dt = new Date(data.date);
    const dateStr = `${dt.getFullYear()}年${dt.getMonth() + 1}月${dt.getDate()}日 ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;
    const deposit = data.cash_summary.deposit || { total: 0, count: 0 };
    const withdrawal = data.cash_summary.withdrawal || { total: 0, count: 0 };
    const expenses = data.cash_summary.expenses || { total: 0, count: 0 };
    const purchase = data.cash_summary.purchase || { total: 0, count: 0 };
    const purchase_payment = data.cash_summary.purchase_payment || { total: 0, count: 0 };
    const refund = data.cash_summary.refund || { total: 0, count: 0 };

    lines.push(dateStr);
    lines.push(`レジNO：${data.register_id}`);
    lines.push(`清算レシート`);
    lines.push('=========================================');

    // 通常販売カテゴリ
    if (data.categories_normal.length > 0) {
        lines.push('＜通常販売＞');
        data.categories_normal.forEach(c => {
            lines.push(`${c.category.padEnd(12)}` + `点数:`.padStart(4, ' ') + `${c.transactions.toString()}`.padStart(3, ' ') +  `現金売上:`.padStart(8, ' ') + `¥${c.cash_sales.toLocaleString()}`.padStart(8, ' '));
            lines.push(`CARD/QR売上:`.padStart(31, ' ') + `¥${c.cashless_sales.toLocaleString()}`.padStart(8, ' '));
            lines.push('');

        });
        lines.push('');
    }

    // 免税販売カテゴリ
    if (data.categories_taxfree.length > 0) {
        lines.push('＜免税販売＞');
        data.categories_taxfree.forEach(c => {
            lines.push(`${c.category.padEnd(12)}` + `点数:`.padStart(4, ' ') + `${c.transactions.toString()}`.padStart(3, ' ') +  `現金売上:`.padStart(8, ' ') + `¥${c.cash_sales.toLocaleString()}`.padStart(8, ' '));
            lines.push(`CARD/QR売上:`.padStart(31, ' ') + `¥${c.cashless_sales.toLocaleString()}`.padStart(8, ' '));
        });
        lines.push('');
    }

    lines.push('=========================================');
    lines.push(`総売上`+`¥${data.total_sales.toLocaleString()}`.padStart(35, ' '));
    lines.push(`総値引き額`+`¥${data.total_discount.toLocaleString()}`.padStart(31, ' '));
    lines.push(`消費税`+`¥${data.total_tax.toLocaleString()}`.padStart(35, ' '));
    lines.push(`売上点数`+`${data.total_items}`.padStart(33, ' '));
    lines.push(`平均単価`+`¥${Math.round(data.average_unit_price).toLocaleString()}`.padStart(33, ' '));
    lines.push('=========================================');

    lines.push('＜仕入・買取＞');
    lines.push(`買取` +`${purchase_payment.count}件`.padStart(27, ' ') +  `¥${purchase_payment.total.toLocaleString()}`.padStart(9, ' '));
    lines.push(`仕入` +`${purchase.count}件`.padStart(27, ' ') +  `¥${purchase.total.toLocaleString()}`.padStart(9, ' '));
    lines.push('');

    lines.push('＜入出金明細＞');
    lines.push(`入金` +`${deposit.count}件`.padStart(27, ' ') + ` ¥${deposit.total.toLocaleString()}`.padStart(9, ' '));
    lines.push(`出金` +`${withdrawal.count}件`.padStart(27, ' ') +  `¥${withdrawal.total.toLocaleString()}`.padStart(9, ' '));
    lines.push(`経費` +`${expenses.count}件`.padStart(27, ' ') +  `¥${expenses.total.toLocaleString()}`.padStart(9, ' '));
    lines.push('');

    lines.push(`返品` +`${refund.count}件`.padStart(27, ' ') +  `¥${refund.total.toLocaleString()}`.padStart(9, ' '));
    lines.push('');

    lines.push(`現金決済額`+`¥${data.cash_sales.toLocaleString()}`.padStart(31, ' '));
    lines.push(`免税キャッシュレス`+`¥${data.taxfree_cashless_total.toLocaleString()}`.padStart(23, ' '));
    lines.push('=========================================');
    lines.push(`現金残高`+`¥${Math.round(data.cash_balance).toLocaleString()}`.padStart(33, ' '));
    lines.push('=========================================');


    return lines.join('\n');
}
